import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetRoadmapClientMappingOutputDto } from '../../../models/roadmap/dto/roadmap.dto';

export const ROADMAP_CLIENT_MAPPING_QUERY_KEY = ['roadmap', 'client-mapping'];

// Elevated-admin only. Pass `enabled` from useIsElevatedAdmin so we never call
// the endpoint for non-elevated admins (it would 403).
export const useGetRoadmapClientMapping = (enabled: boolean) => {
    const client = useApiClient();

    return useQuery({
        enabled,
        queryKey: ROADMAP_CLIENT_MAPPING_QUERY_KEY,
        queryFn: () =>
            client.fetchApi<GetRoadmapClientMappingOutputDto, {}>({
                endpoint: 'roadmap/admin/client-mapping',
                method: 'GET',
            }),
        staleTime: 60_000,
    });
};
